<div class="error-container-inner">
  <ion-icon *ngIf="icon" [name]="icon"></ion-icon>
  <ng-content></ng-content>
  <ng-container *ngIf="translatedText">{{ translatedText }}</ng-container>
  <ion-button *ngIf="retryText" color="secondary" class="retry" (click)="retry.emit()">{{ retryText }} </ion-button>
</div>
